// ---- 勾選項目固定順序（用 parameterName，語系無關）----
import { ReturnParameterInFilter } from '../../../schemas/ReturnParameterInFilter';
import { ReturnParameterValueInFilter } from '../../../schemas/ReturnParameterValueInFilter';

export const CHECKBOX_ORDER_BY_PARAMETER_NAME = [
    'stock',
    'Features Automotive',
    'Features RoHS',
    'Features High Reliability',
] as const;

const CHECKBOX_PRIORITY: Map<string, number> = new Map(
    CHECKBOX_ORDER_BY_PARAMETER_NAME.map((k, i) => [k as string, i])
);

// ---- 品牌固定順序（用 parameterValues[*].value，語系無關）----
export const BRAND_ORDER_BY_VALUE = ['YAGEO', 'KEMET', 'PULSE'] as const;
const BRAND_PRIORITY: Map<string, number> = new Map(
    BRAND_ORDER_BY_VALUE.map((k, i) => [k as string, i])
);

// 勾選項目排序：先依固定順序（parameterName），其餘用 sortIndex，再用顯示名字母序
// Case-insensitive、語言無關的字母序（用 'und' 或直接 toLowerCase 比較都可）
const cmpAscii = (a: string, b: string) => a.localeCompare(b, 'und', { sensitivity: 'base' });

export function sortCheckboxParams(params: ReturnParameterInFilter[]): ReturnParameterInFilter[] {
    return [...params].sort((a, b) => {
        // 1) 固定優先權（parameterName）
        const aP = CHECKBOX_PRIORITY.get(a.parameterName);
        const bP = CHECKBOX_PRIORITY.get(b.parameterName);
        if (aP !== undefined && bP !== undefined) return aP - bP;
        if (aP !== undefined) return -1;
        if (bP !== undefined) return 1;

        // 2) 備援：sortIndex（有就先排）
        const ai = a.sortIndex ?? Number.POSITIVE_INFINITY;
        const bi = b.sortIndex ?? Number.POSITIVE_INFINITY;
        if (ai !== bi) return ai - bi;

        // 3) 最終備援：parameterName 字母序（語言無關）
        return cmpAscii(a.parameterName ?? '', b.parameterName ?? '');
    });
}

export function sortMfgValues(
    values: ReturnParameterValueInFilter[]
): ReturnParameterValueInFilter[] {
    return [...values].sort((a, b) => {
        const aKey = (a.value ?? '').toString();
        const bKey = (b.value ?? '').toString();

        // 1) 固定品牌優先權（value）
        const aP = BRAND_PRIORITY.get(aKey);
        const bP = BRAND_PRIORITY.get(bKey);
        if (aP !== undefined && bP !== undefined) return aP - bP;
        if (aP !== undefined) return -1;
        if (bP !== undefined) return 1;

        // 2) 最終備援：value 字母序（語言無關）
        return cmpAscii(aKey, bKey);
    });
}
